document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".faq__item");

  const colors = [
    "#FF7700",
    "#FFC300",
    "#2D929A",
    "#49B16E",
    "#F13B39"
  ];

  let colorIndex = 0;

  items.forEach(item => {
    const button = item.querySelector(".faq__question");
    const answer = item.querySelector(".faq__answer");
    const icon = item.querySelector(".faq__icon");

    gsap.set(answer, { height: 0 });

    button.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");

      items.forEach(i => {
        i.classList.remove("is-open");
        i.querySelector(".faq__question").style.color = "#fff";
        i.querySelector(".faq__icon").style.color = "#fff";

        gsap.to(i.querySelector(".faq__answer"), {
          height: 0,
          duration: 0.45,
          ease: "power2.out"
        });
      });

      if (!isOpen) {
        const activeColor = colors[colorIndex % colors.length];
        colorIndex++;

        item.classList.add("is-open");

        button.style.color = activeColor;
        icon.style.color = activeColor;

        gsap.to(answer, {
          height: "auto",
          duration: 0.5,
          ease: "power2.out"
        });
      }
    });
  });
});
